import React from 'react';

import { LinearProgress } from '@mui/material';

import { useGetReportingLeLens } from '~/hooks/apis/reporting/useGetReportingLeLens';

import PersonalViewBoundary from './PersonalViewBoundary';
import { useViewEntryRevision } from './useViewEntryRevision';

/** A directly shared Lens uses exactly the same server permission check as the report itself. */
export default function SharedPersonalLens({ lensId, children }: { lensId: string; children: React.ReactNode }) {
  const report = useGetReportingLeLens(lensId);
  const entryRevision = useViewEntryRevision();
  if (report.isPending) return <LinearProgress aria-label="Loading shared report" />;
  if (!report.data?.lens) return <>{children}</>;
  return (
    <PersonalViewBoundary
      key={`${lensId}:${entryRevision}`}
      lensId={lensId}
      reportVersion={report.data.publication?.publishedVersion ?? report.data.lens.version}
    >
      {children}
    </PersonalViewBoundary>
  );
}
